// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"pT-z","inlineTitle":"qT-z","sponsoredAdsWrapper":"rT-z","marketplaceRecosWrapper":"sT-z"};